import log from 'salvo-lite/log'

class MenuImageHover {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        this._imageContent = this._elem.querySelector('.megamenu__image-content')
        this._imageToHide = this._elem.querySelector('.megamenu__image .main-image')
        this._imageToReplace = this._elem.querySelector('.megamenu__image .hover-image')
        this._originalImage = this._imageToReplace.getAttribute('src')
        log.debug(this.constructor.name, 'Constructed', this)
    }

    onInit () {
        let hoverLinks = this._elem.querySelectorAll('.link-hover-image a')
        hoverLinks.forEach(link => {
            let hoverImage = link.getAttribute('data-menu-hover-image')
            link.addEventListener('mouseenter', e => {
                this._imageToHide.classList.add('hide')
                this._imageToReplace.setAttribute('src', hoverImage, function () {})
                this._imageToReplace.classList.remove('hide')
                this._imageContent.classList.add('hide')
            })
        })
    }
}

export default MenuImageHover



// WEBPACK FOOTER //
// ./src/resources/scripts/components/MenuImageHover.js